import { tss } from 'tss-react/mui';

export const useStatsStyles = tss.withName('ProcessSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(14, '6%'),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    inner: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    eyebrow: {
        color: theme.palette.primary.main,
        display: 'block',
        marginBottom: theme.spacing(6),
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: theme.spacing(3),
        },
    },
    step: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    index: {
        color: theme.palette.primary.main,
    },
    connector: {
        flex: '0 0 60px',
        height: 1,
        backgroundColor: theme.palette.divider,
        margin: theme.spacing(0, 2),
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}));
